/*
 * @FilePath: /netHallOfficialAccounts/src/store/getters.js
 */
const getters = {
    // user
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    bindInfo: state => state.user.bindInfo,
    loginStatus: state => state.user.loginStatus,
    homeInfo: state => state.user.homeInfo,
    dictory: state => state.dict.dictory,
    businessNews: state => state.user.businessNews,
    dictoryBycode_STATUS_CODE: state => state.dict.dictoryBycode_STATUS_CODE,
    dictoryBycode_BUS_CODE: state => state.dict.dictoryBycode_BUS_CODE
  };

  export default getters;
